import {Component, Inject, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ApikeysService} from '../apikeys.service';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {PageHeaderDataService} from '../../../../shared/services/page-header-data.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NotificacionesService} from '../../../../_app_services/notificaciones.service';
import {PageHeaderData} from '../../../../shared/components/forms-header/page-header-data';

@Component({
  selector: 'app-form-apikeys',
  templateUrl: './form-apikeys.component.html',
  styleUrls: ['./form-apikeys.component.scss']
})
export class FormApikeysComponent  implements OnInit {
  data = null;
  dis = true;
  constructor(
    public router: Router,
    public service: ApikeysService,
    public dialog: MatDialog,
    private headerDataService: PageHeaderDataService,
    public notificacionService: NotificacionesService,
    private fb: FormBuilder,
  ) {
    this.data = this.router.getCurrentNavigation().extras.state;
  }

  ngOnInit(): void {
    this.headerDataService.setHeaderData(new PageHeaderData('Api Key', '/procesadora/apikeys', true));
  }

  construirFormGroup(): FormGroup {
    return this.fb.group({
      nombreFantasia: [{value: this.data.nombreFantasia ?? '', disabled: this.dis}, Validators.required],
      web: [{value:  this.data.web ?? '', disabled: this.dis}, Validators.required],
      ruc: [{value: this.data.ruc ??  '', disabled: this.dis}, Validators.required],
      email: [{value: this.data.email ??  '', disabled: this.dis}, Validators.required],
      apiKeyProduction: [{value: this.data.apiKeyProduction ??  '', disabled: this.dis}, Validators.required],
      apiKeyTest: [{value: this.data.apiKeyTest ?? '', disabled: this.dis}, Validators.required],
      urlProduction: [{value: this.data.urlProduction ??  '', disabled: this.dis}, Validators.required],
      urlTest: [{value: this.data.urlTest ?? '', disabled: this.dis}, Validators.required],
      publicKeyProduction: [{value: this.data.publicKeyProduction ?? '', disabled: this.dis}, Validators.required],
      publicKeyTest: [{value: this.data.publicKeyTest ??  '', disabled: this.dis}, Validators.required],
      codigo: [{value: this.data.codigo ??  '', disabled: this.dis}, Validators.required],
    });
  }

}
